<template>
  <div style="margin:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Compare Drivers History</span><br/>
      <span style="font-style: italic; font-size: 18px">history of sync events executed</span>
    </div>

    <div style="font-size: 22px; font-weight: bold; position: relative; margin: 30px" class="d-flex align-items-center justify-content-center">
      <a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"/>
      &nbsp;to&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_toDate" :config="options" :placeholder="details_toDate"/>
      &nbsp;<a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      &nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
      <b-button v-on:click.prevent="load_data()" :disabled="loading">Get Results</b-button>
      &nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
      Types:&nbsp;<b-form-select v-model="event_type" :options="type_options" style="font-size: 20px; font-weight: bold; width:310px"/>
      &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;Filter Results&nbsp;<b-form-input style="width: 260px" v-model="event_filter"/>
    </div>

    <div v-if="!loading">
      <div class="row" style="margin: 30px 10px 30px 10px; font-weight: bold; font-size: 22px;">
        <div class="col" style="border: 1px solid grey;">Total: {{items_full.length}}</div>
        <div class="col" style="border: 1px solid grey;">Filtered: {{items.length}}</div>
      </div>
    </div>

    <div>
      <b-table :busy="loading" sticky-header="70vh" bordered :items="items" :fields="fields"
               :current-page="currentPage" :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

        <template slot="processed_time" slot-scope="row">
          {{row.item.processed_time | formatDateTimeSmall}}
        </template>

        <template slot="payload" slot-scope="row">
          <span v-if="row.item.event_type == 'ADD DRIVER TO TBN'">
            {{row.item.payload.firstName}} {{row.item.payload.lastName}}
          </span>
        </template>

        <template slot="details" slot-scope="row">
          <b-button size="sm" @click="row.toggleDetails">
            {{ row.detailsShowing ? '-' : '+' }}
          </b-button>
        </template>

        <template slot="row-details" slot-scope="row">
          <b-card style="text-align: left;">
            <pre style="width: 800px; display: flex; flex-wrap: wrap">{{ row.item.payload }}</pre>
          </b-card>
        </template>

      </b-table>
      <b-row>
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

import {api_url, get_compare_drivers_history} from '../networking/tbn_apis'
import {mapState} from "vuex";
import moment from 'moment'
import {justDate} from "@/helpers/dates";
import axios from 'axios';

export default {
  name: 'compare_drivers_history',
  components: {
  },

  data() {
    return {
      event_filter: '',
      items: [],
      items_full: [],
      summary: [],
      loading: true,
      details_toDate: justDate(moment().add(1, 'days')),
      details_fromDate: justDate(moment()),
      event_type: '',
      confirmed_state:'',
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pages: [],
      type_options: [
        { value: '', text: 'All Types' },
        { value: 'ADD DRIVER', text: 'Add Driver' },
        { value: 'SYNC PROFILE', text: 'Sync Profile' },
      ],
      fields_all: [],
      fields: [
        { key: 'details', label: '', sortable: true},
        { key: 'processed_time', sortable: true},
        { key: 'updated_by', sortable: true},
        { key: 'event_type',sortable: true},
        { key: 'payload', label: 'Record', sortable: true, thStyle: { width: "400px" }},
      ]
      ,
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(90, 'days'),
        maxDate: moment().add(90, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
        toolbarPlacement: 'top',
      },

    }
  },

  async created() {
    this.fields_all = this.fields
    this.load_data()
  },
  methods: {
    async load_data() {
      this.loading = true
      try {
        const {value: { data = [] } } = await get_compare_drivers_history(this.user.tenant, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
            moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.items_full = data.results
        this.filter_results()
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
      this.details_toDate = moment(this.details_toDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    filter_results() {
      this.items = this.items_full
      if (this.event_type != '')
        this.items = this.items.filter(item => (item.event_type.indexOf(this.event_type) != -1))
      if (this.event_filter != '') {
        const val = this.event_filter
        this.items = this.items.filter(item => (this.contains(item.payload, val)))
      }
    },
    contains(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
      }
      return false;
    }

  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
    },
    event_type() {
      this.filter_results();
    },
    category_filter() {
      this.filter_results();
    },
    event_filter() {
      this.filter_results()
    }
  }
}
</script>

<style>

div.row:nth-child(even) {
  background-color: #f2f2f2 !important;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

.header {
  font-weight: bold;
}

div.col {
  border: 1px solid grey;
}

.table td {
  padding: .1rem !important;
}

.mvmt-table td {
  vertical-align: middle !important;
}

div.wrap {
  border: 1px solid grey;
  flex-wrap: wrap;
  display: flex;
  inline-size: 150px;
  /* overflow-wrap: break-word; */
}

</style>

